import { PrintableBody2 } from '../../../printable-styles/printable-typography';
import { useDigitalGuides } from '../../context';
import { PrepElement } from '../../types/prepr';
import BlockContent from '../BlockContent';
import BlockWithIcon from '../BlockWithIcon';

type Props = {
  keyVocabulary: PrepElement | undefined;
};

export default function ChallengesBlockVocabulary({ keyVocabulary }: Props) {
  const { t } = useDigitalGuides();

  if (!keyVocabulary) return null;

  return (
    <BlockWithIcon icon="UserRegisterIcon">
      <BlockContent title={t('digitalguides.key_vocabulary')}>
        <PrintableBody2>{keyVocabulary.body}</PrintableBody2>
      </BlockContent>
    </BlockWithIcon>
  );
}
